module.exports = __webpack_public_path__ + "static/media/CssIco.c1804feb.webp";